// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "main{background:radial-gradient(#f0f0f0,#f5f5f5)}.v-data-table tbody td{cursor:pointer}section{background-color:#fff;border-radius:15px;box-shadow:0 15px 10px rgba(0,0,0,.1);margin-bottom:24px;padding:1em}section:last-of-type{margin-bottom:0}.no-wrap{white-space:nowrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
